import React from 'react';
import { StyledLinkWrapper, StyledLink, styles } from './FindLink.styles';
import { useTopLevelLinks } from '@shared/components/Marcom/useTopLevelLinks';

const FindLink: React.FC = () => {
  const topLevelLinks = useTopLevelLinks();
  return (
    <StyledLinkWrapper __css={styles.linkWrapper}>
      <StyledLink as="a" href={topLevelLinks.findACouple.href} target={topLevelLinks.findACouple.target} onClick={topLevelLinks.findACouple.onClick} __css={styles.link}>
        {topLevelLinks.findACouple.label}
      </StyledLink>
    </StyledLinkWrapper>
  );
};

export default FindLink;
